import styled from "styled-components";

const Styled = styled.section`
    background: #fff;
    border-radius: 24px;
    color: #000;
    display: flex;
    gap: 16px;
    flex-direction: column;
    overflow: hidden;
    padding: 32px 96px 32px 32px;
    position: relative;

    & > h1 {
        bottom: 0;
        color: #000;
        font-family: var(--font-mono), monospace;
        font-size: 4.8rem;
        font-weight: bold;
        letter-spacing: -.5rem;
        margin: 0;
        opacity: .05;
        pointer-events: none;
        position: absolute;
        right: -1rem;
        white-space: nowrap;
        writing-mode: sideways-lr;
    }
`;

export default function Box(props) {
    const { children, name, ...restProps } = props;
    return (
        <Styled { ...restProps }>
            <h1>{ name }</h1>
            { children }
        </Styled>
    );
}
